import React from "react";
import "../../assets/css/seller-info.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import {
	cat12,
	detail_order_img,
	product_inventory,
	star,
} from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_edit_info = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8 refunr-ore pus">
							<Seller_tabs_list />
							<div className="seller-info-wrapper">
								<div className="edit-head-wrapper">
									<h6>Add Business Info</h6>
								</div>
								<div className="info-form-wrappe">
									<form action="">
										<div className="form-group row">
											<div className="col-lg-5">
												<label htmlFor="First Name:">Business name</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum "
												/>
											</div>
											<div className="col-lg-2  px-0"></div>
											<div className="col-lg-5">
												<label htmlFor="First Name">Trade License Number</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum "
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-4">
												<label htmlFor="Email">Email</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
											<div className="col-lg-4">
												<label htmlFor="First Name:">Owner Name</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
											<div className="col-lg-4">
												<label htmlFor="First Name:">Business Type</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-5">
												<label htmlFor="First Name:">
													Business Contact Number
												</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
											<div className="col-lg-2  px-0"></div>
											<div className="col-lg-5">
												<label htmlFor="First Name:">
													Main Products Catagories
												</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-12">
												<label htmlFor="First Name:">Head Office Address</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
										</div>
										<div
											className="form-group row"
											style={{ marginTop: "40px" }}
										>
											<div className="col-lg-8">
												<div className="form-check">
													<input
														className="form-check-input"
														type="checkbox"
														value=""
														id="flexCheckDefault"
													/>
													<label
														className="form-check-label"
														for="flexCheckDefault"
													>
														Lorem ipsum dolor sit amet, consetetur sadipscing
														elitr,
													</label>
												</div>
											</div>
											<div className="col-lg-4">
												<div className="button-group text-end">
													<button className="btn">Save Changes</button>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_edit_info;
